// redux/bestsellerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBestSellerBanner } from "../services/products.service";

export const fetchBestsellerBanner = createAsyncThunk(
  "bestseller/fetchBestsellerBanner",
  async (_, { rejectWithValue }) => {
    try {
      return await getBestSellerBanner(); // ✅ already clean data
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const bestsellerSlice = createSlice({
  name: "bestseller",
  initialState: {
    banner: [],      // ✅ ALWAYS array
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBestsellerBanner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBestsellerBanner.fulfilled, (state, action) => {
        state.loading = false;
        state.banner = action.payload; // ✅ ONLY API DATA
      })
      .addCase(fetchBestsellerBanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bestsellerSlice.reducer;